import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-bootstrap/Popover';
import Overlay from 'react-bootstrap/Overlay';

const DeleteButton = ({
    confirmDelete,
    disabled,
    onClick,
    itemName,
    showText
}) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const target = useRef(null);

    const deleteAction = confirmDelete ? () => setShowConfirm(true) : onClick;

    return (
        <div ref={target}>
            <div className="action-button"
                disabled={disabled}
                onClick={disabled ? null : deleteAction}
                tabIndex="0">
                <img src="/images/x.svg" alt="Delete" />
                {showText && <span> Delete</span>}
            </div>
            <Overlay
                show={showConfirm}
                target={target.current}
                placement="left"
                containerPadding={20}
            >
                <Popover id="delete-confirm">
                    <Popover.Content>
                        <div>
                            <div className="delete-message">
                                Delete this {itemName}?
                                        </div>
                            <div className="d-inline-flex justify-content-around align-top w-100">
                                <div style={{ flexBasis: 'auto' }}>
                                    <div className="action-button" onClick={() => {
                                        setShowConfirm(false);
                                        onClick();
                                    }}>
                                        <div>Confirm</div>
                                    </div>
                                </div>
                                <div style={{ flexBasis: 'auto' }}>
                                    <div className="action-button" onClick={() => setShowConfirm(false)}>
                                        <div>Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popover.Content>
                </Popover>
            </Overlay>
        </div>
    );
}

DeleteButton.propTypes = {
    onClick: PropTypes.func,
    itemName: PropTypes.string,
    showText: PropTypes.bool,
    confirmDelete: PropTypes.bool,
    disabled: PropTypes.bool
};

DeleteButton.defaultProps = {
    confirmDelete: true,
    disabled: false,
    itemName: 'record',
    showText: true
}

export default DeleteButton;
